import {StyleSheet, css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {GRAY} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function AddSampleTypeButton({
  onClick,
  isDisabled,
}: {
  onClick: () => void;
  isDisabled: boolean;
}): JSX.Element {
  return (
    <BenchlingIcon
      className={classNames('simpleDivTable-addButton', {
        [css(styles.disabled)]: isDisabled,
      })}
      icon="compose"
      onClick={onClick}
    />
  );
}

const styles = StyleSheet.create({
  disabled: {
    color: GRAY,
    cursor: 'default',
    pointerEvents: 'none',
  },
});
